const translation = {
  // ─── Layout ───────────────────────────────────────────────────────────────
  "nav.analytics": "数据分析",
  "nav.recommendations": "推荐问题",
  "nav.feedback": "答案反馈",
  "layout.adminConsole": "管理控制台",
  "layout.logout": "退出登录",
  "layout.logoutConfirm": "确定要退出登录吗？",
  "layout.loggingOut": "退出中...",
  "layout.confirmYes": "确定",
  "layout.confirmNo": "取消",

  // ─── Common ───────────────────────────────────────────────────────────────
  "common.all": "全部",
  "common.active": "启用",
  "common.inactive": "停用",
  "common.cancel": "取消",
  "common.close": "关闭",
  "common.clear": "清除",
  "common.confirm": "确定",
  "common.filter": "筛选",
  "common.dateRange": "日期范围",
  "common.save": "保存",
  "common.edit": "编辑",
  "common.remove": "移除",
  "common.required": "必填",
  "common.delete": "删除",
  "common.details": "详情",
  "common.viewDetails": "查看详情",
  "common.note": "备注",
  "common.actions": "操作",
  "common.status": "状态",
  "common.type": "类型",
  "common.total": "总计",
  "common.helpful": "有用",
  "common.unhelpful": "无用",
  "common.export": "导出",
  "common.items": "条",
  "common.loadError": "加载数据失败",
  "common.saveError": "保存失败",
  "common.exportError": "导出失败",
  "common.search": "搜索",
  "common.backToList": "返回列表",
  "common.onTarget": "达标",
  "common.belowTarget": "低于目标",
  "common.today": "今天",
  "common.thisMonth": "本月",
  "common.last7Days": "最近7天",
  "common.last30Days": "最近30天",
  "common.customRange": "自定义",
  "common.manual": "手动",
  "common.auto": "自动",
  "common.combined": "综合",
  "common.clicks": "点击",
  "common.queries": "查询",
  "common.source": "来源",
  "common.topic": "主题",
  "common.allTopics": "全部主题",
  "common.pinned": "置顶",
  "common.personalized": "个性化",
  "common.globalTrending": "全局热门",
  "common.collapse": "收起",
  "common.expand": "展开",
  "common.expandDetails": "展开查看详情",
  "common.noDataFound": "未找到匹配记录",
  "common.noData": "暂无数据",
  "common.loading": "加载中...",
  "common.users": "用户",
  "common.study": "个研究",
  "common.studies": "个研究",
  "common.saving": "保存中...",
  "common.add": "添加",
  "common.adding": "添加中...",
  "common.deleting": "删除中...",
  "common.reset": "重置",
  "common.retry": "重试",
  "common.back": "返回",
  "common.pagination.range": "第 {{from}} - {{to}} 条 / 共 {{total}} 条",
  "common.pagination.previous": "上一页",
  "common.pagination.next": "下一页",
  "common.pagination.page": "第 {{page}} 页",
  "common.pagination.pageNumber": "页码",

  // Admin - Studies
  "studies.title": "研究管理",
  "studies.subtitle": "管理所有临床研究项目。查看研究详情、关联 CRA，并创建新项目。",
  "studies.newStudy": "新建研究",
  "studies.searchPlaceholder": "按名称、代码或 CRA 搜索...",
  "studies.searchBtn": "搜索",
  "studies.reset": "重置",
  "studies.table.name": "研究名称",
  "studies.table.code": "研究代码",
  "studies.table.cra": "关联 CRA",
  "studies.table.members": "成员",
  "studies.table.createdAt": "创建时间",
  "studies.table.actions": "操作",
  "studies.table.reports": "份报告",
  "studies.table.noResults": "未找到研究项目",
  "studies.table.noResultsHint": "尝试调整搜索或筛选条件",
  "studies.detail.title": "研究详情",
  "studies.detail.studyName": "研究名称",
  "studies.detail.studyCode": "研究代码",
  "studies.detail.cra": "关联 CRA",
  "studies.detail.createdAt": "创建时间",
  "studies.detail.reports": "报告数",
  "studies.detail.close": "关闭",
  "studies.detail.notFound": "未找到研究项目",
  "studies.detail.tabMembers": "成员",
  "studies.detail.tabSources": "来源",
  "studies.detail.membersCount": "{{count}} 名成员",
  "studies.detail.membersEmpty": "暂无成员",
  "studies.detail.membersEmptyHint":
    "该研究暂无成员。自动同步成员将从 Teams / SharePoint 自动同步，你也可以手动添加 CRA。",
  "studies.detail.membersLoadFailed": "加载 Study 成员失败。",
  "studies.detail.memberSearchPlaceholder": "搜索成员姓名或邮箱...",
  "studies.detail.dgSync": "DG Sync Settings",
  "studies.detail.dgModalTitle": "Configure Distribution Group Sync",
  "studies.detail.dgStatus": "同步状态",
  "studies.detail.dgStatusEnabled": "已开启",
  "studies.detail.dgStatusEnabledDesc": "已开启：参与计划同步。",
  "studies.detail.dgStatusDisabled": "已关闭",
  "studies.detail.dgStatusDisabledDesc":
    "已关闭：保存后立即触发一次同步，清理该通讯组的成员访问权限。有其他来源的成员仍保留在 Study 中。",
  "studies.detail.dgEmail": "Distribution Group Email",
  "studies.detail.dgEmailPlaceholder": "例如 study-group@company.com",
  "studies.detail.dgIncludeNested": "Include Nested Groups",
  "studies.detail.dgDescription": "Description",
  "studies.detail.dgDescriptionPlaceholder": "输入此 Distribution Group 同步的说明...",
  "studies.detail.dgSaveAndSync": "Save & Sync",
  "studies.detail.dgNestedTooltip": "递归检索嵌套通讯组中的用户，需要 GroupMember.Read.All 权限。",
  "studies.detail.dgDetailTitle": "Distribution Group 同步",
  "studies.detail.dgLastSyncTime": "上次同步时间",
  "studies.detail.dgLastSynced": "上次同步",
  "studies.detail.dgLastSyncStatus": "上次同步状态",
  "studies.detail.dgSyncedUserCount": "已同步用户数",
  "studies.detail.dgSyncSuccess": "同步成功",
  "studies.detail.dgSyncFailed": "同步失败",
  "studies.detail.dgSyncing": "同步中...",
  "studies.detail.dgSyncingHint": "正在从通讯组同步成员。",
  "studies.detail.dgSyncingToast": "同步已开始，正在后台从通讯组同步成员...",
  "studies.detail.dgYes": "是",
  "studies.detail.dgNo": "否",
  "studies.detail.dgEdit": "编辑",
  "studies.detail.dgDisable": "停用",
  "studies.detail.dgEnable": "启用",
  "studies.detail.dgDisableTitle": "停用 Distribution Group 同步？",
  "studies.detail.dgDisableDesc":
    "这将停用该通讯组并立即触发一次同步。同步成功后，没有其他来源的成员将从该 Study 中移除。",
  "studies.detail.dgSaveFailed": "Distribution Group 同步配置保存失败",
  "studies.detail.addMember": "添加成员",
  "studies.detail.addMemberTitle": "添加手动成员",
  "studies.detail.addMemberDesc":
    "手动添加的 CRA 将获得该研究下所有来源的访问权限。手动成员优先于自动同步。",
  "studies.detail.addMemberSearch": "搜索 CRA 用户...",
  "studies.detail.addMemberSearchHint": "请输入 ITCode 或邮箱进行搜索。",
  "studies.detail.addMemberSearching": "正在搜索 CRA 用户...",
  "studies.detail.addMemberNoResults": "未找到匹配的 CRA 用户",
  "studies.detail.addMemberAlreadyAssigned": "已分配",
  "studies.detail.addMemberConfirm": "确认添加",
  "studies.detail.removeMemberTitle": "移除成员",
  "studies.detail.removeMemberDesc":
    "将 {{name}} 从该研究的成员列表中移除。自动同步成员无法手动移除。",
  "studies.detail.removeMemberConfirm": "确认移除",
  "studies.detail.tagAutoSync": "自动同步",
  "studies.detail.tagManual": "手动",
  "studies.detail.colName": "姓名",
  "studies.detail.colEmail": "邮箱",
  "studies.detail.colSource": "来源",
  "studies.detail.colAddedAt": "添加时间",
  "studies.detail.paginationPrevious": "上一页",
  "studies.detail.paginationNext": "下一页",
  "studies.detail.paginationPage": "第 {{page}} 页",
  "studies.detail.colAction": "操作",
  "studies.detail.sourcesEmpty": "暂无来源",
  "studies.detail.sourcesEmptyHint": "该研究尚未配置来源。请前往 Study Source 设置添加来源。",
  "studies.detail.colConnection": "连接方式",
  "studies.detail.colChannelName": "来源站点",
  "studies.detail.colUserListSync": "用户列表同步",
  "studies.detail.userListSourceYes": "是",
  "studies.detail.userListSourceNo": "否",
  "studies.detail.memberSource.teams": "Teams 频道",
  "studies.detail.memberSource.sharepoint": "SharePoint 站点",
  "studies.detail.memberSource.dg": "DG",
  "studies.detail.view": "查看",
  "studies.detail.sourceFilter.all": "全部来源",
  "studies.detail.filterNoResults": "没有符合该来源筛选的成员",
  "studies.modal.title": "创建新研究",
  "studies.modal.editTitle": "编辑研究",
  "studies.modal.studyName": "研究名称",
  "studies.modal.studyNameRequired": "*",
  "studies.modal.studyNamePlaceholder": "例如：eVolve Meso Phase II",
  "studies.modal.studyCode": "研究代码",
  "studies.modal.studyCodeRequired": "*",
  "studies.modal.studyCodePlaceholder": "例如：D7986C0001",
  "studies.modal.associatedCra": "关联 CRA",
  "studies.modal.optional": "（可选）",
  "studies.modal.searchMoreCra": "继续搜索...",
  "studies.modal.searchCraPlaceholder": "按姓名或邮箱搜索...",
  "studies.modal.noMatchingCra": "未找到匹配用户",
  "studies.modal.allCraSelected": "已选择全部可用用户",
  "studies.modal.saveFailed": "研究保存失败",
  "studies.modal.cancel": "取消",
  "studies.modal.create": "创建研究",
  "studies.toast.created": "研究创建成功",
  "studies.toast.updated": "研究更新成功",
  "studies.more": "更多",
  "studies.showLess": "收起",
  "studies.loadFailed": "研究列表加载失败",
  "studies.detailLoadFailed": "研究详情加载失败",
  "studies.craLoadFailed": "CRA 用户加载失败",
  "studies.pagination": "第 {{from}} - {{to}} 条 / 共 {{total}} 条",

  // Admin - Users
  "users.title": "用户与权限",
  "users.subtitle": "用户来源于 AZ SSO。为每个用户分配角色并控制其对研究文档来源的访问权限。",
  "users.addUser": "添加用户",
  "users.searchPlaceholder": "按名称、邮箱或 K 账号搜索...",
  "users.searchBtn": "搜索",
  "users.role": "角色",
  "users.role.all": "全部角色",
  "users.role.staff": "Staff",
  "users.role.cra": "CRA",
  "users.role.csm": "CSM",
  "users.role.admin": "Admin",
  "users.role.auditor": "Auditor",
  "users.role.manager": "Manager",
  "users.status": "状态",
  "users.status.all": "全部状态",
  "users.table.user": "用户",
  "users.table.studies": "研究项目",
  "users.table.statusLastActive": "状态 / 最近活跃",
  "users.table.actions": "操作",
  "users.table.noResults": "未找到用户",
  "users.table.noResultsHint": "尝试调整搜索或筛选条件",
  "users.table.edit": "编辑权限",
  "users.table.disable": "禁用用户",
  "users.table.enable": "启用用户",
  "users.table.noAccess": "无系统访问权限",
  "users.table.noLocalRole": "未分配角色",
  "users.table.showLess": "收起",
  "users.table.more": "更多",
  "users.table.site": "site",
  "users.table.sites": "sites",
  "users.stats.totalUsers": "用户总数",
  "users.stats.active": "已激活",
  "users.stats.inactive": "未激活",
  "users.stats.byRole": "按角色",
  "users.stats.percentOfTotal": "占总数的 {pct}%",
  "users.status.active": "已激活",
  "users.status.inactive": "未激活",
  "users.status.disabled": "已禁用",
  "users.modal.title": "添加用户",
  "users.modal.subtitle": "输入 K-Account 以从 AZ SSO 导入",
  "users.modal.kAccount": "K-Account",
  "users.modal.kAccountRequired": "*",
  "users.modal.kAccountPlaceholder": "例如：smithj01",
  "users.modal.verify": "验证",
  "users.modal.verifying": "验证中...",
  "users.modal.verified": "已在 AZ SSO 中验证",
  "users.modal.notFound": "在 AZ SSO 中未找到",
  "users.modal.notFoundDesc":
    "此 K-Account 在 AZ SSO 中尚不存在。您仍可导入，该用户将在首次通过 SSO 登录时被激活。",
  "users.modal.role": "角色",
  "users.modal.role.staff": "Staff",
  "users.modal.role.staffDesc": "仅 Ask Q&A 访问权限",
  "users.modal.role.cra": "CRA",
  "users.modal.role.csm": "CSM",
  "users.modal.role.csmDesc": "Ask Q&A + MVR 报告访问权限",
  "users.modal.role.craDesc": "Ask Q&A + MVR 报告访问权限",
  "users.modal.role.admin": "Admin",
  "users.modal.role.adminDesc": "所有功能的完全访问权限",
  "users.modal.role.manager": "Manager",
  "users.modal.role.managerDesc": "只读管理控制台访问权限",
  "users.modal.role.auditor": "Auditor",
  "users.modal.role.auditorDesc": "只读管理控制台访问权限",
  "users.modal.studyAccess": "研究",
  "users.modal.studyAccessRequired": "*",
  "users.modal.studyHint": "按 Enter 或 , 添加代码。可一次性粘贴多个。",
  "users.modal.platformStudies": "平台研究项目",
  "users.modal.searchStudy": "搜索或输入研究代码...",
  "users.modal.addMore": "添加更多...",
  "users.modal.allAdded": "所有平台研究项目已添加",
  "users.modal.typeToSearch": "输入以搜索或输入自定义代码",
  "users.modal.clearAll": "清空全部",
  "users.modal.status": "状态",
  "users.modal.statusActive": "已激活",
  "users.modal.importHint": "用户将以已激活状态导入。您随时可以编辑权限。",
  "users.modal.cancel": "取消",
  "users.modal.import": "导入并激活",
  "users.modal.studyError": "CRA 角色至少需要填写一个研究代码。",
  "users.modal.kAccountError": "请输入 K-Account",
  "users.modal.exists": "此用户已存在于系统中",
  "users.form.title": "分配权限",
  "users.form.subtitle": "管理该用户的角色和研究权限",
  "users.form.back": "返回用户与权限",
  "users.form.userInfo": "用户信息",
  "users.form.readOnly": "(只读)",
  "users.form.accountStatus": "账户状态",
  "users.form.canLogin": "可以登录",
  "users.form.cannotLogin": "无法登录",
  "users.form.roleTitle": "角色",
  "users.form.roleDesc": "为该用户选择一个或多个角色",
  "users.form.studyTitle": "研究",
  "users.form.studyDesc": "输入研究代码并按 Enter 或 , 添加。可一次性粘贴多个。",
  "users.form.siteTitle": "Site 权限",
  "users.form.siteDesc": "选择该 Staff 用户可访问的 Site，Site 数据来源于 Ask Source 管理页面。",
  "users.form.save": "保存权限",
  "users.toast.updated": "用户更新成功",
  "users.toast.created": "用户创建成功",
  "users.toast.added": "用户添加成功",
  "users.toast.saved": "用户保存成功",
  "users.toast.deleted": "用户删除成功",
  "users.toast.imported": "已导入并激活",
  "users.toast.disabled": "已禁用 — 仅 Ask 访问权限",
  "users.toast.reEnabled": "已重新启用",

  // ─── Feedback List ────────────────────────────────────────────────────────
  "feedback.title": "答案反馈",
  "feedback.subtitle": "查看并分析用户对 AI 答案的反馈",
  "feedback.overview": "反馈总览",
  "feedback.unhelpfulRate": "无用反馈率",
  "feedback.helpfulRate": "有用反馈率",
  "feedback.target": "目标",
  "feedback.targetBelow2": "目标 < 2%",
  "feedback.targetAbove95": "目标 > 95%",
  "feedback.searchPlaceholder": "搜索问题或对话 ID...",
  "feedback.filterType": "类型",
  "feedback.allTypes": "全部类型",
  "feedback.feedbackTime": "反馈时间",
  "feedback.questionTitle": "问题标题",
  "feedback.conversationId": "对话 ID",
  "feedback.user": "用户",
  "feedback.sourceDocs": "来源文档",
  "feedback.reason": "原因",
  "feedback.noRecords": "暂无反馈记录",
  "feedback.addNote": "添加备注",
  "feedback.feedbackId": "反馈 ID",
  "feedback.notePlaceholder": "输入内部备注（仅管理员可见）...",
  "feedback.saveNote": "保存备注",
  "feedback.reasonPlaceholder": "例如：回答内容不完整，缺少关键细节...",
  "feedback.clickToEdit": "点击编辑原因",
  "feedback.totalAnswers": "答案总数",
  "feedback.totalAnswersDesc": "AI 累计生成答案",
  "feedback.feedbackCount": "反馈数",
  "feedback.feedbackRate": "反馈率",
  "feedback.feedbackRateDesc": "反馈数 / 答案总数",
  "feedback.feedbackRateTooltip":
    "收到反馈的答案数 ÷ AI 答案总数 × 100%，衡量用户主动对答案进行评价的参与程度",
  "feedback.helpfulRateTooltip":
    "标记为「有用」的反馈数 ÷ 总反馈数 × 100%，衡量用户对 AI 答案满意的比例",
  "feedback.unhelpfulRateTooltip":
    "标记为「无用」的反馈数 ÷ 总反馈数 × 100%，衡量用户对 AI 答案不满意的比例",
  "feedback.helpfulShort": "有用 {{count}}",
  "feedback.unhelpfulShort": "无用 {{count}}",

  // ─── Feedback Detail ──────────────────────────────────────────────────────
  "feedbackDetail.title": "反馈详情",
  "feedbackDetail.subtitle": "查看完整的反馈上下文和相关信息",
  "feedbackDetail.notFound": "未找到该反馈记录",
  "feedbackDetail.basicInfo": "基本信息",
  "feedbackDetail.feedbackTime": "反馈时间",
  "feedbackDetail.conversationId": "对话 ID",
  "feedbackDetail.username": "用户名",
  "feedbackDetail.sourceDocuments": "来源文档",
  "feedbackDetail.documents": "份文档",
  "feedbackDetail.userQuestion": "用户问题",
  "feedbackDetail.systemAnswer": "系统回答",
  "feedbackDetail.sourceDocsSection": "来源文档",
  "feedbackDetail.viewDocument": "查看文档",
  "feedbackDetail.noSourceDocs": "暂无来源文档",
  "feedbackDetail.unhelpfulReason": "无用反馈原因",
  "feedbackDetail.userComments": "用户评论",
  "feedbackDetail.internalNote": "内部备注",
  "feedbackDetail.editNote": "编辑备注",
  "feedbackDetail.notePlaceholder": "添加内部备注，用于问题分析和跟进记录...",
  "feedbackDetail.noNote": "暂无内部备注",
  "feedbackDetail.noteSaved": "备注已保存",

  // ─── Analytics ────────────────────────────────────────────────────────────
  "analytics.title": "数据分析总览",
  "analytics.subtitle": "监控系统性能与用户参与度",
  "analytics.penetrationSection": "AI 使用渗透情况",
  "analytics.qualitySection": "AI 运营质量分析",
  "analytics.currentWeek": "本自然周",
  "analytics.weeklyPenetrationTrend": "近8周渗透趋势",
  "analytics.weeklyPenetrationTrendTooltip":
    "活跃用户率与高参与率按自然周统计的历史趋势，反映用户活跃度的周环比变化。",
  "analytics.activeUserRate": "活跃用户率",
  "analytics.activeUserTooltip":
    "活跃用户：每周与 AI 互动 > 3 次。活跃用户率 = 活跃用户数 / 总注册用户数，目标 > 50%。",
  "analytics.activeUserTooltipNew":
    "以自然周为统计单位。活跃用户率 = 本自然周内与 AI 互动 ≥ 3 次的用户数 ÷ 总注册用户数，目标 > 50%。",
  "analytics.highlyEngagedRate": "高参与率",
  "analytics.highlyEngagedTooltip":
    "高参与用户：每周与 AI 互动 > 10 次。参与率 = 高参与用户数 / 总注册用户数，目标 > 20%。",
  "analytics.highlyEngagedTooltipNew":
    "以自然周为统计单位。高参与率 = 本自然周内与 AI 互动 ≥ 10 次的用户数 ÷ 总注册用户数，目标 > 20%。",
  "analytics.helpfulRate": "有用回答率",
  "analytics.helpfulRateTooltip":
    '有用回答：被用户标记为"有用"的 AI 回答。有用回答率 = 有用回答数 / 总回答数，越高越好，目标 > 95%。',
  "analytics.helpfulRateTooltipNew":
    "所选时间范围内有用回答数 ÷ 所选时间范围内回答总数，越高越好，目标 > 95%。",
  "analytics.unhelpfulRate": "无用回答率",
  "analytics.unhelpfulRateTooltip":
    '无用回答：被用户标记为"无用"的 AI 回答。无用回答率 = 无用回答数 / 总回答数，越低越好，目标 < 2%。',
  "analytics.unhelpfulRateTooltipNew":
    "所选时间范围内无用回答数 ÷ 所选时间范围内回答总数，越低越好，目标 < 2%。",
  "analytics.engagementTrend": "用户参与趋势",
  "analytics.engagementTrendTooltip":
    "活跃用户率与参与率的时间序列视图，便于识别用户活跃周期和波动情况。",
  "analytics.activeUserRateLabel": "活跃用户率",
  "analytics.engagementRateLabel": "参与率",
  "analytics.satisfaction": "用户满意度",
  "analytics.satisfactionTooltip":
    "用户满意度 = 有用回答数 / 总反馈数，反映用户对 AI 回答的整体满意程度，越高越好。",
  "analytics.satisfactionTooltipNew":
    "所选时间范围内有用回答数 ÷ 所选范围内反馈总数，反映用户对 AI 回答的整体满意程度，越高越好。",
  "analytics.satisfactionLabel": "满意度",
  "analytics.totalFeedback": "总反馈数",
  "analytics.responseTime": "响应时间",
  "analytics.responseTimeTooltip":
    "用 P75 与 P95 分位数衡量响应时延分布。短期目标：75% 的回答时延 < 15 秒；长期目标：95% 的回答时延 < 15 秒。",
  "analytics.responseTimeLabel": "响应时长",
  "analytics.shortTermGoal": "短期目标（Short Term）",
  "analytics.longTermGoal": "长期目标（Long Term）",
  "analytics.p75Tooltip":
    "75% 的回答响应时延 < 15 秒。反映大多数用户在正常负载下的实际体验，是当前阶段的短期达标基准。",
  "analytics.p95Tooltip":
    "95% 的回答响应时延 < 15 秒。覆盖慢请求场景，代表全体用户的整体体验，是系统持续优化的长期目标。",
  "analytics.targetWithin": "目标 <",
  "analytics.recentTrend": "近8天趋势",
  "analytics.avgResponseTime": "平均响应时间",
  "analytics.below15sRate": "15秒内响应率",
  "analytics.p75LatencyDesc": "75% 的回答时延",
  "analytics.p95LatencyDesc": "95% 的回答时延",
  "analytics.unhelpfulReasonDist": "无用反馈原因分布",
  "analytics.unhelpfulReasonTooltip":
    "用户将回答标记为无用时选择的原因，有助于识别 AI 回答的主要弱点，指导模型优化。",
  "analytics.share": "数量",
  "analytics.count": "数量",

  // ─── Recommended Questions ────────────────────────────────────────────────
  "rec.title": "推荐问题",
  "rec.subtitle": "管理展示给用户的快捷问题，系统自动展示人气最高的6个。",
  "rec.newQuestion": "新建问题",
  "rec.statTotal": "总计",
  "rec.statActive": "启用",
  "rec.statPinned": "已置顶",
  "rec.statAutoCaptured": "自动捕获",
  "rec.statTotalClicks": "总点击",
  "rec.statTotalQueries": "总查询",
  "rec.filterStatus": "状态：",
  "rec.filterSource": "来源：",
  "rec.filterTopic": "主题：",
  "rec.sortLabel": "排序：",
  "rec.sortCombined": "综合",
  "rec.sortClicks": "点击",
  "rec.sortQueries": "查询",
  "rec.searchPlaceholder": "搜索问题...",
  "rec.autoCaptured": "自动捕获",
  "rec.simpleSubtitle": "管理展示给用户的推荐问题，最多启用 6 个",
  "rec.slotCount": "{{count}}/6 已配置",
  "rec.slotsTitle": "推荐问题配置",
  "rec.slotsHint": "按顺序展示，用户将看到这 6 个问题",
  "rec.emptySlot": "空位 — 悬停添加",
  "rec.addQuestion": "添加问题",
  "rec.deleteConfirm": "确认删除？",
  "rec.noQuestions": "暂未配置推荐问题",
  "rec.addFirstQuestion": "添加第一个问题",
  "rec.bottomHint": "鼠标悬停到每一行可进行编辑或删除操作",
  "rec.enabledSection": "已启用问题",
  "rec.disabledSection": "已停用问题",
  "rec.enabledCount": "{{count}}/6 已启用",
  "rec.dragToReorder": "拖拽行可调整展示顺序",
  "rec.dragHandle": "拖拽排序",
  "rec.enable": "启用",
  "rec.disable": "停用",
  "rec.enabledHint": "排在上方的问题显示在前台推荐列表的前面；拖拽左侧图标可调整顺序",
  "rec.disableConfirm": "确认停用？",
  "rec.maxEnabledHint": "已达上限，停用一个问题后才能继续启用",
  "rec.noEnabledQuestions": "暂无已启用的推荐问题",
  "rec.noDisabledQuestions": "所有问题均已启用",
  "rec.operationFailed": "操作失败，请重试",

  // ─── Question Table ───────────────────────────────────────────────────────
  "table.source": "来源",
  "table.question": "问题",
  "table.topic": "主题",
  "table.buttonClicks": "按钮点击",
  "table.searchQueries": "搜索查询",
  "table.combinedScore": "综合得分",
  "table.pin": "置顶",
  "table.pinTitle": "置顶到 Top 6",
  "table.unpinTitle": "取消置顶",
  "table.edit": "编辑",
  "table.totalCount": "共 {{count}} 条问题",
  "table.autoNote": "自动 = 从用户输入中捕获的高频问题",
  "table.pinnedNote": "置顶问题不受人气排名影响",
  "table.noResults": "未找到匹配问题",

  // ─── Recommendation Config ────────────────────────────────────────────────
  "recConfig.title": "推荐设置",
  "recConfig.autoUpdateOn": "自动更新已开启",
  "recConfig.pinnedCount": "已置顶 {{count}} 条",
  "recConfig.autoUpdateTop6": "自动更新 Top 6",
  "recConfig.autoUpdateDesc": "系统每日自动将最热门的问题推送到 Top 6",
  "recConfig.autoUpdateOffDesc": "已禁用：仅显示管理员置顶的问题",
  "recConfig.rankingMetric": "排名指标",
  "recConfig.metricCombined": "综合得分",
  "recConfig.metricCombinedDesc": "点击 + 查询，最综合全面",
  "recConfig.metricClicks": "按钮点击",
  "recConfig.metricClicksDesc": "仅统计推荐按钮点击次数",
  "recConfig.metricQueries": "搜索查询",
  "recConfig.metricQueriesDesc": "仅统计用户输入的查询次数",
  "recConfig.personalizationTrigger": "个性化触发阈值",
  "recConfig.personalizationTriggerDesc": "达到多少次互动后切换为个性化推荐",
  "recConfig.personalizationTimes": "{{count}} 次",
  "recConfig.pinnedNote": "已置顶 {{count}} 条问题，始终出现在 Top 6，不受人气影响",
  "recConfig.autoCapturedNote": "已从用户输入中自动捕获 {{count}} 条高频问题",
  "recConfig.newUsersNote": "新用户看到全局 Top 6；达到 {{count}} 次互动后激活个性化推荐",

  // ─── Personalization Config ───────────────────────────────────────────────
  "personConfig.title": "个性化规则",
  "personConfig.activatesAfter": "{{count}} 次互动后激活",
  "personConfig.algorithmFlow": "算法流程",
  "personConfig.step1Title": "追踪用户行为",
  "personConfig.step1a": "点击了哪些推荐问题",
  "personConfig.step1b": "在搜索框输入了哪些关键词",
  "personConfig.step1c": "查看了哪些主题的答案",
  "personConfig.step2Title": "分析主题偏好",
  "personConfig.step2a": "统计每个主题的互动次数",
  "personConfig.step2b_on": "最近 {{count}} 天的行为权重 ×2",
  "personConfig.step2b_off": "全部历史行为等权重",
  "personConfig.step2c": "生成用户主题偏好得分",
  "personConfig.step3Title": "个性化排名",
  "personConfig.step3a": "从偏好主题中挑选得分最高的 {{mixRatio}} 条",
  "personConfig.step3b": "用全局热门问题填满剩余 {{globalCount}} 个位置",
  "personConfig.step3c": "置顶问题始终保留",
  "personConfig.step4Title": "展示给用户",
  "personConfig.step4a": "替代全局默认 Top 6",
  "personConfig.step4b": "每次打开页面实时计算",
  "personConfig.step4c": "偏好模型持续优化",
  "personConfig.ruleConfig": "规则配置",
  "personConfig.dataSource": "偏好数据来源",
  "personConfig.dataSourceDesc": "使用哪种行为数据来判断用户主题偏好",
  "personConfig.dsCombined": "综合（推荐）",
  "personConfig.dsCombinedDesc": "点击 + 查询",
  "personConfig.dsClicks": "按钮点击",
  "personConfig.dsClicksDesc": "仅统计推荐问题点击",
  "personConfig.dsQueries": "搜索查询",
  "personConfig.dsQueriesDesc": "仅统计用户输入查询",
  "personConfig.recency": "近期加权",
  "personConfig.recencyOnDesc": "最近 {{count}} 天的行为权重为历史数据的 2 倍",
  "personConfig.recencyOffDesc": "全部历史行为等权重",
  "personConfig.mixRatio": "个性化 / 全局混合比例",
  "personConfig.mixRatioDesc": "6 条推荐中，有多少来自用户偏好主题",
  "personConfig.mixPersonalized": "{{count}} 条个性化",
  "personConfig.mixGlobal": "{{count}} 条全局热门",
  "personConfig.simulation": "模拟——不同用户类型将看到的内容",
  "personConfig.userWillSee": "该用户将看到：",
  "personConfig.plusGlobal": "+ {{count}} 条全局热门",

  // ─── Question Preview ─────────────────────────────────────────────────────
  "preview.title": "当前默认展示——所有新用户均可见",
  "preview.rankedBy": "排名依据：",
  "preview.autoRefreshed": "每日自动刷新",
  "preview.autoUpdateDisabled": "自动更新已关闭",
  "preview.livePreview": "实时预览",
  "preview.noActive": "暂无启用的推荐问题",
  "preview.pinnedNote": "置顶图标 = 管理员置顶，不受人气排名影响",
  "preview.scoreNote": "数字 = {{metric}}（越高排名越靠前）",
  "preview.personalizationNote": "达到 {{count}} 次互动后激活个性化推荐",
  "preview.metricCombined": "综合得分",
  "preview.metricClicks": "按钮点击",
  "preview.metricQueries": "搜索查询",

  // ─── Edit Question ────────────────────────────────────────────────────────
  "editQ.titleNew": "新建问题",
  "editQ.titleEdit": "编辑问题",
  "editQ.subtitleNew": "添加新的推荐快捷问题",
  "editQ.subtitleEdit": "问题 ID：",
  "editQ.questionContent": "问题内容",
  "editQ.questionPlaceholder": "输入推荐问题，例如：如何提交差旅报销申请？",
  "editQ.questionHint": "请使用疑问句格式，建议 50 字以内，便于用户快速浏览",
  "editQ.topicCategory": "主题分类",
  "editQ.topicDesc": "选择该问题所属的主题，用于个性化推荐。",
  "editQ.selectedTopics": "已选：",
  "editQ.priority": "优先级",
  "editQ.priorityDesc": "数值越高，在用户 Top 6 推荐中优先级越高（1–10）",
  "editQ.low14": "低 1–4",
  "editQ.mid57": "中 5–7",
  "editQ.high810": "高 8–10",
  "editQ.highPriority": "高优先级",
  "editQ.midPriority": "中优先级",
  "editQ.lowPriority": "低优先级",
  "editQ.pinToTop6": "置顶到 Top 6",
  "editQ.pinDesc": "开启后，无论人气排名如何，该问题始终出现在推荐列表中",
  "editQ.pinnedNote": "该问题已置顶，管理员可随时取消置顶。",
  "editQ.statusLabel": "状态",
  "editQ.activeDesc": "将出现在前端推荐列表中",
  "editQ.inactiveDesc": "暂时隐藏，数据保留",
  "editQ.createQuestion": "创建问题",
  "editQ.saveChanges": "保存修改",
  "editQ.savedRedirecting": "保存成功，正在跳转...",

  // ─── System Settings Nav ──────────────────────────────────────────────────
  "nav.settings": "系统设置",
  "nav.pathSettings": "路径设置",
  "nav.studySource": "Study Source",
  "nav.updateLogs": "更新日志",
  "nav.userPermissions": "用户权限",

  // ─── Update Logs ──────────────────────────────────────────────────────────
  "updateLogs.title": "文档更新日志",
  "updateLogs.subtitle": "追踪文档库的每次更新记录，确保各模块始终获取最新版本文档",
  "updateLogs.syncNow": "立即同步",
  "updateLogs.syncing": "同步中...",
  "updateLogs.syncedAt": "已于 {{time}} 同步",
  "updateLogs.lastSynced": "上次同步于 {{time}}",
  "updateLogs.addLog": "添加记录",
  "updateLogs.editLog": "编辑记录",
  "updateLogs.statTotal": "总记录数",
  "updateLogs.statThisMonth": "本月更新",
  "updateLogs.statMVR": "MVR 更新",
  "updateLogs.statGeneral": "通用库更新",
  "updateLogs.filterModule": "模块",
  "updateLogs.filterType": "更新类型",
  "updateLogs.allModules": "全部模块",
  "updateLogs.allTypes": "全部类型",
  "updateLogs.searchPlaceholder": "搜索数据源、失败文件或同步计数...",
  "updateLogs.colDate": "更新日期",
  "updateLogs.colDocument": "文档名称",
  "updateLogs.colVersion": "版本号",
  "updateLogs.colModule": "所属模块",
  "updateLogs.colType": "更新类型",
  "updateLogs.colDescription": "更新描述",
  "updateLogs.colDataSource": "数据源",
  "updateLogs.colOperator": "操作人",
  "updateLogs.colActions": "操作",
  "updateLogs.typeAdded": "新增",
  "updateLogs.typeModified": "修改",
  "updateLogs.typeRemoved": "删除",
  "updateLogs.typeRenamed": "重命名",
  "updateLogs.noRecords": "暂无更新记录",
  "updateLogs.formDocName": "文档名称",
  "updateLogs.formDocNamePlaceholder": "输入文档名称",
  "updateLogs.formVersion": "版本号",
  "updateLogs.formVersionPlaceholder": "例：v2.1.0",
  "updateLogs.formModule": "所属模块",
  "updateLogs.formUpdateType": "更新类型",
  "updateLogs.formDate": "更新日期",
  "updateLogs.formDescription": "更新描述",
  "updateLogs.formDescPlaceholder":
    "详细描述本次更新内容，例如：根据 IRB 反馈修改了第 4.2 节内容...",
  "updateLogs.formOperator": "操作人",
  "updateLogs.formOperatorPlaceholder": "输入操作人姓名",
  "updateLogs.deleteConfirm": "确定要删除该日志记录吗？",
  "updateLogs.deleted": "记录已删除",
  "updateLogs.saved": "记录保存成功",
  "updateLogs.totalCount": "共 {{count}} 条记录",
  "updateLogs.filesInvolved": "本次涉及文件",
  "updateLogs.fileCount": "{{count}} 个",
  "updateLogs.updatedFilesPrefix": "，本次更新了",
  "updateLogs.updatedFilesSuffix": "个文件",
  "updateLogs.systemAutoSync": "系统自动同步",
  "updateLogs.adminManualSync": "管理员手动同步",
  "updateLogs.loading": "正在加载...",
  "updateLogs.loadFailed": "同步日志加载失败，请稍后重试",
  "updateLogs.syncSummaryChanged": "本次同步扫描 {{scanned}} 个文件，检测到 {{changed}} 个文件变更",
  "updateLogs.syncSummaryNoChange": "本次同步未检测到文件变更，共扫描 {{scanned}} 个文件",
  "updateLogs.syncSummaryDetail":
    "本次同步实际扫描 {{scanned}} 个文件：新增 {{added}} 个，更新 {{updated}} 个，跳过 {{skipped}} 个，删除 {{deleted}} 个，失败 {{failed}} 个。",
  "updateLogs.failedDetailsTitle": "{{count}} 个失败文件",
  "updateLogs.unknownFile": "未知文件",
  "updateLogs.unknownFailureReason": "未知失败原因",
  "updateLogs.countScanned": "扫描",
  "updateLogs.countAdded": "新增",
  "updateLogs.countRetried": "重试",
  "updateLogs.countUpdated": "更新",
  "updateLogs.countSkipped": "跳过",
  "updateLogs.countDeleted": "删除",
  "updateLogs.countFailed": "失败",
  "updateLogs.sourceError": "源端错误",
  "updateLogs.viewFiles": "查看文件",
  "updateLogs.hideFiles": "收起",
  "updateLogs.filesPanelTitle": "{{label}}文件清单",
  "updateLogs.fileCountSuffix": "{{count}} 个文件",
  "updateLogs.viewAllSuccessTitle": "{{label}} · 成功文件",
  "updateLogs.viewAllFailedTitle": "{{label}} · 失败文件",
  "uploadLogs.files": "个文件",
  "uploadLogs.succeeded": "成功",
  "uploadLogs.failedFiles": "失败文件",
  "uploadLogs.viewAll": "查看全部",
  "uploadLogs.markTooltip": "标记为已处理",
  "uploadLogs.unmarkTooltip": "取消标记",

  // ─── Login ──────────────────────────────────────────────────────────────
  "login.title": "AstraZeneca OpsMate Platform",
  "login.subtitle": "登录以访问管理后台",
  "login.username": "用户名",
  "login.usernamePlaceholder": "请输入用户名",
  "login.password": "密码",
  "login.passwordPlaceholder": "请输入密码",
  "login.submit": "登录",
  "login.loggingIn": "登录中...",
  "login.copyright": "版权所有",
  "login.errorRequired": "请输入用户名和密码",
  "login.errorFailed": "用户名或密码错误",
  "login.orDivider": "或",
  "login.ssoButton": "企业 SSO 登录",
  "login.ssoLoading": "正在跳转到 SSO...",
  "login.ssoFailed": "SSO 登录失败，请重试。",
  "login.ssoError.provider_error": "SSO 提供方返回错误。",
  "login.ssoError.missing_params": "缺少授权参数，请重新登录。",
  "login.ssoError.state_expired": "SSO 会话无效或已过期，请重试。",
  "login.ssoError.no_id_token": "未返回身份令牌，请重试。",
  "login.ssoError.nonce_mismatch": "SSO 安全校验失败，请重试。",
  "login.ssoError.no_oid": "账号缺少必要的身份信息。",
  "login.ssoError.no_permission": "您没有登录权限，请联系管理员。",
  "login.ssoError.account_disabled": "该账号已被禁用，请联系管理员。",
  "login.ssoError.login_failed": "SSO 登录失败，请重试。",

  // ─── OpsMate ──────────────────────────────────────────────────────────────
  "opsmate.aiReasoning": "AI 推理",
  "opsmate.helpImprove": "帮助我们改进这个回答",
  "opsmate.helpImproveDesc": "请告诉我们这个回答为什么没能帮助到您（可多选）",
  "opsmate.otherReason": "其他原因（可选）",
  "opsmate.otherReasonPlaceholder": "选填——帮助我们更好地理解您的反馈",
  "opsmate.acknowledgeBtn": "我已知悉并继续",
  "opsmate.skip": "跳过",
  "opsmate.submit": "提交",
  "opsmate.loadingAgreement": "正在获取是否同意协议...",
  "opsmate.termsAccepted": "已接受用户使用条款。",
  "opsmate.termsAcceptFailed": "接受条款失败",
  "opsmate.disclaimer": {
    part1: "AZ OpsMate ",
    part2: "未经 GCP 验证",
    part3: "，使用 AZ OpsMate 即表示您已阅读并理解",
    termsOfUse: "使用条款",
    part4: "。",
  },
  "opsmate.agreeTerms": "使用此功能即表示您同意",
  "opsmate.termsLink": "使用条款",
  "opsmate.pinned": "已置顶。",
  "opsmate.unpinned": "已取消置顶。",
  "opsmate.pinFailed": "置顶对话失败",
  "opsmate.unpinFailed": "取消置顶对话失败",
  "opsmate.missingSessionLog": "未获取到当前答案的 SessionLogId，无法提交反馈",
  "opsmate.dislikeReasonRequired": "请选择至少一条原因或输入自定义原因",
  "opsmate.feedbackFailed": "反馈提交失败",
  "opsmate.feedbackSubmitting": "正在提交反馈...",
  "opsmate.feedbackMarkedUseful": "已标记为有用回答",
  "opsmate.feedbackMarkedNotUseful": "已标记为无用回答",
  "opsmate.feedbackUpdated": "反馈已更新",
  "opsmate.feedbackCancelledLike": "已取消点赞",
  "opsmate.feedbackRetryLater": "反馈失败，请稍后重试",
  "opsmate.translationFailed": "翻译失败",
  "opsmate.dislikeReason1": "答案不正确或有错误",
  "opsmate.dislikeReason2": "与我的问题不相关",
  "opsmate.dislikeReason3": "信息不完整或缺少关键细节",
  "opsmate.dislikeReason4": "内容过于模糊或不可操作",
  "opsmate.dislikeReason5": "引用来源不合适",
  "opsmate.dislikeReason6": "答案生成时间过长",
  "opsmate.regenerate": "重新生成",

  // ─── OpsMate > Agreement ──────────────────────────────────────────────────
  "opsmate.agreement.title": "OpsMate 使用条款",
  "opsmate.agreement.tocTitle": "使用条款目录",

  // ─── OpsMate > ConversationsMenus ─────────────────────────────────────────
  "opsmate.menu.title": "OpsMate",
  "opsmate.menu.rename": "重命名",
  "opsmate.menu.pinToTop": "置顶",
  "opsmate.menu.unpinFromTop": "取消置顶",
  "opsmate.menu.delete": "删除",
  "opsmate.menu.expand": "展开",
  "opsmate.menu.collapse": "收起",
  "opsmate.menu.today": "今天",
  "opsmate.menu.yesterday": "昨天",
  "opsmate.menu.last7Days": "最近 7 天",
  "opsmate.menu.last30Days": "最近 30 天",
  "opsmate.menu.last1Month": "最近 1 个月",
  "opsmate.menu.last6Months": "最近 6 个月",
  "opsmate.menu.older": "更早",
  "opsmate.menu.pinnedGroup": "已置顶",
  "opsmate.menu.deleteTitle": "永久删除对话",
  "opsmate.menu.deleteDesc": "删除后无法恢复，确定要删除吗？",
  "opsmate.menu.confirm": "确定",
  "opsmate.menu.cancel": "取消",
  "opsmate.menu.deleted": "已删除。",
  "opsmate.menu.deleteFailed": "删除对话失败",
  "opsmate.menu.renameFailed": "重命名对话失败",
  "opsmate.menu.searchPlaceholder": "搜索对话...",
  "opsmate.menu.noData": "暂无数据",
  "opsmate.menu.reachedBottom": "已经到底",

  // ─── OpsMate > CustomerSuggestion ─────────────────────────────────────────
  "opsmate.suggestion.q1": "如何提交差旅报销？",
  "opsmate.suggestion.q2": "哪些费用可以报销？",
  "opsmate.suggestion.q3": "出差酒店预订政策",
  "opsmate.suggestion.q4": "IT 设备申请流程",
  "opsmate.suggestion.q5": "加班和请假政策",
  "opsmate.suggestion.q6": "电子课程的注册流程是什么？",
  "opsmate.suggestion.inputPlaceholder": "输入问题...",
  "opsmate.suggestion.onlySelectedSources": "仅使用选定文档进行提问",
  "opsmate.suggestion.stopped": "生成已停止。",
  "opsmate.suggestion.questionTooLong": "提问内容不能超过 {{max}} 个字符。",
  "opsmate.suggestion.buildingReferences": "正在构建 References ...",
  "opsmate.suggestion.sendFailed": "问题发送失败，请重试。",
  "opsmate.suggestion.sendFailedContent": "抱歉，问题发送失败，请稍后再试。",
  "opsmate.suggestion.greeting": "你好 {{name}}，今天我能帮您什么？",
  "opsmate.suggestion.inputTooltip": "请输入您的问题",
  "opsmate.suggestion.emptySelectedSourcesTooltip": "请先在 Sources 面板中至少选择一个来源",
  "opsmate.suggestion.onlySelectedSourcesTooltip":
    "启用后，AI 仅会在您在 Sources 面板手动勾选的文档中检索答案。",
  "opsmate.suggestion.stopGenerating": "停止生成",
  "opsmate.scopeSelector.generalDocs": "通用文档",
  "opsmate.scopeSelector.studySource": "研究文档",
  "opsmate.scopeSelector.personalDocs": "个人文档",
  "opsmate.scopeSelector.allTypes": "全部类型",
  "opsmate.scopeSelector.allStudies": "我的全部研究",
  "opsmate.scopeSelector.allStudySources": "全部研究来源",

  // ─── OpsMate > Progress (思考过程面板) ────────────────────────────────────
  "opsmate.progress.headerThinkingWithSteps": "思考中 · 已完成 {{count}} 步",
  "opsmate.progress.headerThinking": "思考中…",
  "opsmate.progress.headerCompleted": "已完成思考",
  "opsmate.progress.analyzing": "正在分析您的问题，请稍候…",
  "opsmate.progress.moreDocuments": "… 等共 {{count}} 份文档",
  "opsmate.progress.unknownDoc": "未知文档",
  "opsmate.progress.queryJoiner": "、",
  "opsmate.progress.partSeparator": "，",
  "opsmate.progress.duration.ms": "{{n}} 毫秒",
  "opsmate.progress.duration.s": "{{n}} 秒",
  "opsmate.progress.boolean.yes": "是",
  "opsmate.progress.boolean.no": "否",
  "opsmate.progress.reasoning.failed": "AI 思考过程出现异常",
  "opsmate.progress.reasoning.thinking": "AI 正在思考",
  "opsmate.progress.reasoning.section.thinking": "思考过程",
  "opsmate.progress.reasoning.section.query": "检索问题",
  "opsmate.progress.reasoning.section.toRequest": "是否继续请求资料",
  "opsmate.progress.reasoning.section.retrievalDecision": "是否继续检索",
  "opsmate.progress.reasoning.section.rationale": "判断依据",
  "opsmate.progress.reasoning.section.answer": "候选回答",
  "opsmate.progress.reasoning.section.default": "{{label}}",
  "opsmate.progress.planner.decision.title": "判断是否需要检索资料",
  "opsmate.progress.planner.decision.need": "决定：需要检索更多资料",
  "opsmate.progress.planner.decision.noNeed": "决定：当前信息足够，无需额外检索",
  "opsmate.progress.planner.decision.done": "已完成检索决策",
  "opsmate.progress.planner.queryProposal.titleMulti": "已生成多个检索查询",
  "opsmate.progress.planner.queryProposal.titleSingle": "已生成检索查询",
  "opsmate.progress.planner.queryProposal.keywords": "查询关键词：{{queries}}",
  "opsmate.progress.retrieval.started.title": "正在检索资料",
  "opsmate.progress.retrieval.started.query": "查询关键词：{{query}}",
  "opsmate.progress.retrieval.completed.title": "检索完成",
  "opsmate.progress.retrieval.failed.title": "检索出现错误",
  "opsmate.progress.retrieval.failed.desc": "请稍后重试或换个关键词",
  "opsmate.progress.retrieval.foundNew": "找到 {{count}} 条相关内容",
  "opsmate.progress.retrieval.foundTotal": "检索到 {{count}} 条内容",
  "opsmate.progress.retrieval.duration": "用时 {{duration}}",
  "opsmate.progress.retrieval.results.title": "命中 {{count}} 段相关内容",
  "opsmate.progress.retrieval.results.titleEmpty": "已获取检索结果",
  "opsmate.progress.retrieval.results.fromDocs": "来自 {{count}} 份文档",
  "opsmate.progress.fallback.failed": "处理过程中出现异常",
  "opsmate.progress.fallback.tool": "执行工具调用",
  "opsmate.progress.fallback.reasoningStep": "AI 推理步骤",
  "opsmate.progress.trace.tool.load_skill": "加载技能",
  "opsmate.progress.trace.tool.kb_search": "知识库检索",
  "opsmate.progress.trace.tool.kb_find_documents": "查找文档",
  "opsmate.progress.trace.tool.kb_read": "读取文档",
  "opsmate.progress.trace.tool.kb_get_outline": "读取文档大纲",
  "opsmate.progress.trace.tool.default": "工具调用",
  "opsmate.progress.trace.call.title": "正在执行：{{tool}}",
  "opsmate.progress.trace.result.title": "{{tool}} 已完成",
  "opsmate.progress.trace.result.count": "命中 {{count}} 条结果",
  "opsmate.progress.trace.result.empty": "本次检索未返回结果",
  "opsmate.progress.trace.result.emptyDocs": "未找到相关文档",
  "opsmate.progress.trace.query": "检索词：{{query}}",
  "opsmate.progress.trace.assistant": "AI 阶段性分析",
  "opsmate.progress.trace.loadSkill.call": "正在加载技能",
  "opsmate.progress.trace.loadSkill.done": "技能已就绪",
  "opsmate.progress.trace.skill.knowledgeQa": "知识问答",
  "opsmate.progress.trace.skill.replan": "重新规划检索策略",
  "opsmate.progress.trace.skill.groundedAnswer": "基于证据作答",
  "opsmate.progress.trace.arg.query": "检索词",
  "opsmate.progress.trace.arg.keyword": "关键词",
  "opsmate.progress.trace.arg.topK": "返回数量",
  "opsmate.progress.trace.arg.documentIds": "限定文档",
  "opsmate.progress.trace.arg.documentId": "文档",
  "opsmate.progress.trace.arg.sectionId": "章节",
  "opsmate.progress.trace.arg.skillName": "技能",
  "opsmate.progress.trace.arg.default": "{{label}}",
  "opsmate.progress.trace.arg.allDocs": "全部文档",
  "opsmate.progress.trace.arg.moreItems": " 等 {{count}} 项",
  "opsmate.progress.trace.match.filename": "文件名匹配",
  "opsmate.progress.trace.match.content": "内容匹配",
  "opsmate.progress.status.loadingConfig": "正在加载助手配置…",
  "opsmate.progress.status.assemblingTools": "正在准备工具与技能…",
  "opsmate.progress.status.callingLlm": "正在调用模型…",
  "opsmate.progress.status.runningTool": "正在执行：{{tool}}…",
  "opsmate.progress.status.runningWorkflow": "正在执行工作流：{{workflow}}…",

  // ─── OpsMate > DocumentList ───────────────────────────────────────────────
  "opsmate.docs.sources": "来源",
  "opsmate.docs.expandSources": "展开来源",
  "opsmate.docs.collapseSources": "收起来源",
  "opsmate.docs.selectAll": "全选",
  "opsmate.docs.no_data": "暂无数据",
  "opsmate.docs.emptyDesc": "当前范围没有可用来源，可尝试添加来源或切换知识库范围。",
  "opsmate.docs.basedOnDocs": "答案基于选中的文档生成。",
  "opsmate.docs.sourceTips": "数据每小时更新，最后更新于 {{time}}",
  "opsmate.docs.addSourcesTitle": "添加来源",
  "opsmate.docs.searchPlaceholder": "搜索文档...",
  "opsmate.docs.searchingDocs": "正在搜索文档...",
  "opsmate.docs.noData": "暂无数据",
  "opsmate.docs.allLoaded": "所有文档已加载",
  "opsmate.docs.addSources": "添加来源",
  "opsmate.docs.cancel": "取消",
  "opsmate.docs.confirm": "确定",
  "opsmate.docs.latestUpdate": "最近更新 {{date}}",
  "opsmate.docs.selected": "已选",
  "opsmate.docs.downloadUnavailable": "下载链接暂时不可用。",
  "opsmate.docs.loadFailed": "加载文档失败。",
  "opsmate.docs.filterSelectedCount": "已选 {{count}} 项",
  "opsmate.docs.personalIncluded": "已包含",
  "opsmate.docs.personalExcluded": "未包含",
  "opsmate.docs.loadingMore": "加载更多...",
  "opsmate.docs.openTeamsChannel": "在 Teams Channel 中打开",
  "opsmate.docs.openSharePointSite": "在 SharePoint 中打开",

  // ─── OpsMate > Terms of Use Page ──────────────────────────────────────────
  "opsmate.termsOfUse.pageTitle": "AZ OpsMate - 使用条款",
  "pathSettings.title": "Ask 知识库来源",
  "pathSettings.subtitle": "配置 Ask 模块知识库的 SharePoint 来源路径",
  "studySource.title": "Study Source Settings",
  "studySource.subtitle":
    "管理各研究项目（Study）的文档来源配置，对接 Microsoft Teams Channel / SharePoint Site，每小时同步一次",
  "pathSettings.globalKeywords.title": "全局排除关键词",
  "pathSettings.globalKeywords.tooltip":
    "这些关键词对所有 Site 和 Path 生效。同步和索引时，名称包含任一关键词的文件或文件夹都会被跳过。支持简单子字符串匹配。",
  "pathSettings.globalKeywords.empty": "尚未配置关键词。",
  "pathSettings.globalKeywords.edit": "编辑",
  "pathSettings.globalKeywords.add": "添加",
  "pathSettings.globalKeywords.cancel": "取消",
  "pathSettings.globalKeywords.save": "保存",
  "pathSettings.globalKeywords.loading": "正在加载关键词...",
  "pathSettings.globalKeywords.retry": "重试",
  "pathSettings.globalKeywords.loadFailed": "全局排除关键词加载失败。",
  "pathSettings.globalKeywords.saveFailed": "全局排除关键词保存失败，请重试。",
  "pathSettings.globalKeywords.placeholder": "例如：temp, draft, backup",
  "pathSettings.globalKeywords.inputLabel": "待添加关键词",
  "pathSettings.globalKeywords.remove": "删除 {{keyword}}",
  "pathSettings.addPath": "添加路径",
  "pathSettings.banner.title": "新增 Site 的授权先决条件",
  "pathSettings.banner.desc":
    "在添加新的 SharePoint Site 路径前，请确认 AZ IT 已对系统的 client_id 完成该 Site 的授权。未经授权的 Site 将无法被索引，文件也无法正常访问。请先联系 AZ IT 完成授权后再继续操作。",
  "pathSettings.prereq.modalTitle": "添加路径",
  "pathSettings.prereq.modalSubtitle": "继续操作前，请确认以下事项",
  "pathSettings.prereq.warningTitle": "需要 AZ 授权",
  "pathSettings.prereq.warningDesc":
    "您即将添加的 SharePoint Site 必须由 AZ IT 对系统的 client_id 完成授权。未完成授权时，该路径下的文件将无法被索引或访问。",
  "pathSettings.prereq.checkPermission": "您在目标 Site 拥有 Site Owner 或 Contributor 权限",
  "pathSettings.prereq.checkboxLabel": "我确认 AZ IT 已对该 Site 的 client_id 完成授权",
  "pathSettings.prereq.cancel": "取消",
  "pathSettings.prereq.confirm": "确认 \u2014 继续添加路径",
  "pathSettings.save": "保存",
  "pathSettings.cancel": "取消",
  "pathSettings.add": "添加",
  "pathSettings.loading": "正在加载...",
  "pathSettings.loadFailed": "路径加载失败，请重试。",
  "pathSettings.saveFailed": "路径保存失败，请检查 Included Path 是否已存在。",
  "pathSettings.deleteFailed": "路径删除失败，请重试。",
  "pathSettings.createSuccess": "Source 创建成功",
  "pathSettings.updateSuccess": "Source 更新成功",
  "pathSettings.deleteSuccess": "Source 删除成功",
  "pathSettings.emptyPaths": "暂无路径配置，点击\u300C添加路径\u300D开始配置。",
  "pathSettings.placeholder": "https://astrazeneca.sharepoint.com/sites/...",
  "pathSettings.editTitle": "编辑 General Source",
  "pathSettings.sourceNotFound": "未找到 General Source。",
  "pathSettings.sourceSite": "Source Site",
  "pathSettings.sourceDrive": "Source Drive",
  "pathSettings.sourcePath": "Source Folder Path",
  "pathSettings.includedPaths": "Included Path",
  "pathSettings.excludedPaths": "Excluded Path",
  "pathSettings.docCategories": "文档分类",
  "pathSettings.docTags": "文档标签",
  "pathSettings.operation": "操作",
  "pathSettings.sourceType": "类型",
  "pathSettings.sourceTypeTooltip":
    "来自文档分类管理的分类类别。主要用于控制用户访问权限——用户仅能查看已获授权的类别下的来源。前往 Admin → Source Settings → Document Categories 管理分类。",
  "sourceForm.loadingMeta": "正在加载文档元数据...",
  "sourceForm.docCategories": "文档类别",
  "sourceForm.docCategoriesTooltip":
    "AI 用于分析和分类此路径下文档的类别。AI 文档分析时，会根据文件内容自动将其归入所选类别。前往 Admin → Source Settings → Document Categories 管理分类。",
  "sourceForm.docCategoriesPlaceholder": "从管理后台选择类别...",
  "sourceForm.docTags": "文档标签",
  "sourceForm.docTagsTooltip":
    "从管理后台「文档标签管理」中选择标签并定义标签值。在文档分析时，此路径下的文件将被赋予相应标签。",
  "sourceForm.docTagsSelectTag": "选择标签...",
  "sourceForm.docTagsSelectValues": "选择 {{tag}} 值或输入自定义值...",
  "sourceForm.docTagsTagValues": "输入标签值...",
  "sourceForm.docTagsRemoveGroup": "移除此标签组",
  "sourceForm.docTagsAddTag": "添加标签",
  "sourceForm.docTagsEmpty": "尚未定义标签。请前往 Admin → Source Settings → Document Tags 创建。",
  "sourceForm.sourceTypePlaceholder": "选择文档类别...",
  "sourceForm.sourceTypeEmpty":
    "尚未定义类别。请前往 Admin → Source Settings → Document Categories 创建。",
  "sourceForm.remark": "Description",
  "sourceForm.remarkPlaceholder": "填写给用户查看的 Source 描述...",
  "sourceForm.remarkHint": "此描述将展示在 Ask Sources 页面",
  "sourceForm.agentTips": "Agent 提示",
  "sourceForm.agentTipsTooltip":
    "为 AI Agent 提供说明，帮助它更好地理解此来源。这些提示将指导 AI 在回答中如何使用和解释此来源。",
  "sourceForm.agentTipsPlaceholder":
    "例如：优先使用当前文档而非归档文档。对于合规性问题，务必引用相关法规文件。",
  "sourceForm.agentTipsHint": "这些提示将帮助 AI Agent 引导如何解释和使用此来源",
  "sourceForm.region": "Region",
  "sourceForm.regionTooltip":
    "将此 Source 限定到特定地理区域。所选区域之外的用户不会在知识库结果中看到此 Source。",
  "sourceForm.region.mainland": "Mainland China",
  "sourceForm.region.hongKong": "Hong Kong",
  "sourceForm.userScope": "User Scope",
  "sourceForm.userScopeTooltip": "该 Source 对外部用户的可见性",
  "sourceForm.userScope.internalExternal": "Internal & External",
  "sourceForm.userScope.internalOnly": "AZ Internal Only",
  "pathSettings.sourceSitePlaceholder": "TSM937",
  "pathSettings.allDrives": "全部文档库",
  "pathSettings.sourceDrivePlaceholder": "留空 = 该站点全部文档库",
  "pathSettings.sourceDriveHint":
    "文档库（drive）显示名；留空表示该站点下所有业务库。drive 改名后需同步更新。",
  "pathSettings.sourcePathPlaceholder": "/ 或 /子目录/",
  "pathSettings.includedPathsPlaceholder": "/Archive/HR-Library",
  "pathSettings.excludedPathsPlaceholder": "/Archive/HR-Library/legacy",
  "pathSettings.addPathField": "继续添加",
  "pathSettings.removePathField": "移除",
  "pathSettings.includedPathsHint":
    "需要纳入知识库索引的文件夹路径或文件名。同步整个范围时必须显式填写 /。每个路径/文件对应 SharePoint 驱动器下的一个目录或文件。支持精确路径匹配：可同步单个文件（如 /folder/report.docx），也可同步整个子目录（如 /Archive/HR-Library/legacy）。点击 + 为每个新增路径添加独立输入框。",
  "pathSettings.excludedPathsHint":
    "在上述 Include Paths 范围内需要排除的特定文件或子文件夹。排除规则对该 site 该 drive 下所有 Include Paths 同时生效。支持精确路径匹配：可排除单个文件或整个子目录。点击 + 为每个新增路径添加独立输入框。",
  "pathSettings.deleteConfirmTitle": "删除该路径？",
  "pathSettings.deleteConfirmDesc": "此操作不可撤销。",
  "pathSettings.delete": "删除",
  "pathSettings.pathMustStartWithSlash": "Path 必须以 / 开头",
  "pathSettings.includedPathRequired": "Included Path 必填；同步全部内容时请填写 /",
  "pathSettings.exactPathConflict": '"{{path}}" 已在 Include Paths 中，无法同时排除',
  "pathSettings.excludedAncestorConflict":
    'Exclude 路径 "{{excludedPath}}" 会完全覆盖 Include 路径 "{{includedPath}}"，该 Include 路径将永远不生效。请移除其中一个',
  "pathSettings.searchPlaceholder": "按站点或路径搜索...",
  "pathSettings.globalKeywords.subtitle": "此处关键词将作为全局规则从路径同步中排除。",
  "pathSettings.globalKeywords.addBtn": "添加",
  "pathSettings.filter.allDocCategories": "全部文档分类",
  "pathSettings.filter.allDocTags": "全部文档标签",
  "pathSettings.filter.allSourceTypes": "全部来源类型",
  "pathSettings.filter.allRegions": "全部区域",
  "pathSettings.filter.mainland": "中国大陆",
  "pathSettings.filter.hongkong": "中国香港",
  "pathSettings.filter.allScopes": "全部范围",
  "pathSettings.filter.resetAll": "重置全部",
  "anomaly.filter.timeRange": "时间范围",
  "anomaly.filter.last1Hour": "最近 1 小时",
  "anomaly.filter.last4Hours": "最近 4 小时",
  "anomaly.filter.last24Hours": "最近 24 小时",
  "anomaly.filter.last7Days": "最近 7 天",
  "systemLogs.op.manageHealthMonitor": "管理健康监控",
  "systemLogs.op.manageSecurityRecords": "管理安全记录",
  "systemLogs.op.manageSystemSettings": "管理系统设置",
  "healthMonitor.viewError": "查看详情",
  "healthMonitor.resultDetail.title": "检查结果",
  "healthMonitor.table.noResults": "未找到健康检查记录",
  "healthMonitor.table.noResultsHint": "尝试调整 API 筛选条件",
  "healthMonitor.filter.allApis": "全部 API",
  "healthMonitor.timeAgo.justNow": "刚刚",
  "healthMonitor.timeAgo.minute": "{{count}}分钟前",
  "healthMonitor.timeAgo.minutes": "{{count}}分钟前",
  "healthMonitor.timeAgo.hour": "{{count}}小时前",
  "healthMonitor.timeAgo.hours": "{{count}}小时前",
  "healthMonitor.timeAgo.day": "{{count}}天前",
  "healthMonitor.timeAgo.days": "{{count}}天前",

  // Document Categories
  "docCategories.title": "文档分类管理",
  "docCategories.tooltip":
    "定义和管理用于 AI 文档分析的文档分类类别。这些类别在 General Source、Study Source 及其他模块中用于文档分类。",
  "docCategories.newCategory": "新建分类",
  "docCategories.modal.newTitle": "新建文档分类",
  "docCategories.modal.editTitle": "编辑文档分类",
  "docCategories.categoryName": "分类名称",
  "docCategories.classificationStandard": "分类标准（Prompt）",
  "docCategories.visibleToAllUsers": "全部用户可见",
  "docCategories.defaultSelected": "默认勾选",
  "docCategories.status.enabled": "已开启",
  "docCategories.status.disabled": "未开启",
  "docCategories.placeholder.name": "输入分类名称，例如：Global Standard、SOP...",
  "docCategories.placeholder.prompt": "描述 AI 识别和归类此类文档时应使用的分类规则...",
  "docCategories.searchPlaceholder": "按名称或 Prompt 搜索...",
  "docCategories.count": "{{count}} 个分类",
  "docCategories.table.name": "分类名称",
  "docCategories.table.prompt": "分类标准（Prompt）",
  "docCategories.table.action": "操作",
  "docCategories.empty.noMatching": "未找到匹配的分类",
  "docCategories.empty.noCategories": "暂无分类",
  "docCategories.empty.adjustSearch": "尝试调整搜索条件",
  "docCategories.empty.clickNew": "点击「新建分类」创建一个",
  "docCategories.empty.noPrompt": "未定义 Prompt",
  "docCategories.empty.noPromptNeeded": "无需 Prompt",
  "docCategories.empty.noPromptDefined": "未定义 Prompt",
  "docCategories.customCategories": "自定义分类",
  "docCategories.systemCategories": "系统分类",
  "docCategories.systemCategoriesTooltip":
    "系统分类由平台预定义，跨所有研究项目共享。不可编辑或删除，无需配置分类标准。",
  "docCategories.locked": "已锁定",
  "docCategories.modal.builtInNotice": "这是内置分类，具有受限的编辑权限。",
  "docCategories.modal.deleteTitle": "删除此分类？",
  "docCategories.modal.deleteDesc":
    "「{{name}}」将被永久删除。当前使用该分类的文档将不再被分配此分类。",

  // Document Types
  "docTypes.title": "文档类型管理",
  "docTypes.tooltip":
    "定义和管理文档来源类型。这些类型在用户于 Ask 页面选择来源时作为筛选项使用，帮助缩小知识库检索范围。",
  "docTypes.newType": "新建类型",
  "docTypes.modal.newTitle": "新建文档类型",
  "docTypes.modal.editTitle": "编辑文档类型",
  "docTypes.modal.deleteTitle": "删除此类型？",
  "docTypes.modal.deleteDesc": "「{{name}}」将被永久删除。当前使用该类型的来源将不再被分配此类型。",
  "docTypes.typeName": "类型名称",
  "docTypes.placeholder.name": "例如：法务文件、SOP、HR 政策",
  "docTypes.searchPlaceholder": "按类型名称搜索...",
  "docTypes.count": "{{count}} 个类型",
  "docTypes.table.name": "类型名称",
  "docTypes.table.action": "操作",
  "docTypes.empty.noMatching": "未找到匹配的类型",
  "docTypes.empty.noTypes": "暂无类型",
  "docTypes.empty.adjustSearch": "尝试调整搜索条件",
  "docTypes.empty.clickNew": "点击「新建类型」创建一个",

  // Document Tags
  "docTags.title": "文档标签管理",
  "docTags.tooltip":
    "定义和管理用于 AI 文档分析和元数据提取的文档标签。这些标签在 General Source、Study Source 和个人文档中用于文档分类和元数据提取。",
  "docTags.newTag": "新建标签",
  "docTags.modal.newTitle": "新建文档标签",
  "docTags.modal.editTitle": "编辑文档标签",
  "docTags.tagName": "标签名称",
  "docTags.tagStandard": "标签标准（Prompt）",
  "docTags.placeholder.name": "例如：Study Protocol Number",
  "docTags.placeholder.prompt":
    "例如：从 CSP、CSA 或 ICF 等研究文档中提取方案编号。常见格式包括 ACE-CL-311、D5740C00001。",
  "docTags.searchPlaceholder": "按名称或 Prompt 搜索...",
  "docTags.count": "{{count}} 个标签",
  "docTags.table.name": "标签名称",
  "docTags.table.prompt": "标签标准（Prompt）",
  "docTags.table.action": "操作",
  "docTags.empty.noMatching": "未找到匹配的标签",
  "docTags.empty.noTags": "暂无标签",
  "docTags.empty.adjustSearch": "尝试调整搜索条件",
  "docTags.empty.clickNew": "点击「新建标签」创建一个",
  "docTags.empty.noPromptNeeded": "无需 Prompt",
  "docTags.empty.noPromptDefined": "未定义 Prompt",
  "docTags.personalDocDescription": "将此文档分配给其所属用户。标签值为该用户的唯一 ID。",
  "docTags.modal.deleteTitle": "删除此标签？",
  "docTags.modal.deleteDesc": "「{{name}}」将被永久删除。当前使用该标签的文档将不再被分配此标签。",
  "docTags.modal.builtInNotice": "这是内置标签，具有受限的编辑权限。",
  "docTags.modal.builtInNameCannotEdit": "内置标签名称不可编辑。",
  "docTags.modal.noPromptNeeded": "此内置标签按用户自动分配，不需要 Prompt。",
  "docTags.modal.noPromptRequired": "此内置标签不需要 Prompt。",
  "docTags.locked": "已锁定",
  "docTags.systemTags": "系统标签",
  "docTags.systemTagsTooltip":
    "系统标签由平台预定义，跨所有研究项目共享。不可编辑或删除，部分标签会根据文档元数据自动分配。",
  "docTags.customTags": "自定义标签",
  // Header
  "syncConfig.backToUsers": "返回用户列表",
  "syncConfig.title": "Distribution Group 同步设置",
  "syncConfig.subtitle":
    "本页面用于配置同步 OpsMate 用户的 Distribution Group，并根据用户所属组为其分配区域和默认角色。",
  "syncConfig.reset": "重置",

  // Common
  "syncConfig.cancel": "取消",
  "syncConfig.yes": "是",
  "syncConfig.no": "否",
  "syncConfig.statusLabel": "状态",
  "syncConfig.s1StatusLabel": "同步状态",
  "syncConfig.enabled": "已启用",
  "syncConfig.disabled": "已停用",
  "syncConfig.descriptionLabel": "描述",
  "syncConfig.descriptionPlaceholder": "可选描述...",
  "syncConfig.includeNested": "包含嵌套组",
  "syncConfig.nestedTooltip": "递归检索嵌套通讯组中的用户，需要 GroupMember.Read.All 权限。",
  "syncConfig.emailInvalid": "请输入有效的邮箱地址",

  // Section 1
  "syncConfig.s1Title": "全员 Distribution Group 同步",
  "syncConfig.s1Desc": "同步获准访问 OpsMate 的完整用户列表，并创建或更新平台用户。",
  "syncConfig.s1DgEmailLabel": "Distribution Group 邮箱",
  "syncConfig.s1DgEmailRequired": "Distribution Group 邮箱为必填项",
  "syncConfig.s1DgEmailPlaceholder": "例如 all-users@company.com",
  "syncConfig.s1DgEmailTooltip": "此通讯组的成员将被同步到 OpsMate 用户目录。",
  "syncConfig.s1StatusEnabledHint": "已启用：参与定时同步。",
  "syncConfig.s1StatusDisabledHint": "已停用：停止后续自动同步，但不立即删除已有用户。",
  "syncConfig.lastSyncTime": "上次同步时间",
  "syncConfig.lastSyncStatus": "上次同步状态",
  "syncConfig.lastSyncSuccess": "上次同步成功",
  "syncConfig.syncFailed": "同步失败",
  "syncConfig.syncedUserCount": "已同步用户数",
  "syncConfig.syncing": "同步中...",
  "syncConfig.syncingUsers": "正在从通讯组同步用户...",
  "syncConfig.loadFailed": "同步配置加载失败",
  "syncConfig.saveFailed": "同步配置保存失败",
  "syncConfig.syncAgain": "重新同步",
  "syncConfig.disableSyncTitle": "停用同步？",
  "syncConfig.enableSyncTitle": "启用同步？",
  "syncConfig.disableSyncDesc":
    "这将停止自动用户同步。已有用户将保留在系统中。您可以随时重新启用同步。",
  "syncConfig.enableSyncDesc": "这将根据配置的通讯组恢复自动用户同步。",
  "syncConfig.disableSync": "停用同步",
  "syncConfig.enableSync": "启用同步",

  // Section 2
  "syncConfig.s2Title": "区域与角色分配",
  "syncConfig.s2Desc":
    "从同步的用户目录中识别香港用户。香港 Distribution Group 中的用户将被分配到香港区域并赋予香港员工角色；其余同步用户将被分配到中国大陆并赋予员工角色。",
  "syncConfig.s2HkEmailLabel": "香港 Distribution Group 邮箱",
  "syncConfig.s2HkEmailRequired": "香港 Distribution Group 邮箱为必填项",
  "syncConfig.s2HkEmailPlaceholder": "例如 hk-users@company.com",
  "users.source": "用户来源",
  "users.source.all": "全部用户来源",
  "syncConfig.lastSaved": "上次保存",
  "syncConfig.pendingBanner":
    "配置已保存。待用户目录同步（全员 Distribution Group 同步）完成后，区域与角色分配将应用到用户。",
  "syncConfig.rulesTitle": "区域与默认角色规则",
  "syncConfig.rulesDesc":
    "系统将根据用户是否属于上方配置的 Distribution Group，自动为其分配区域和默认角色。",
  "syncConfig.rulesColClass": "分类",
  "syncConfig.rulesColRegion": "分配区域",
  "syncConfig.rulesColRole": "默认角色",
  "syncConfig.rulesRow1": "用户属于香港 Distribution Group",
  "syncConfig.rulesRow2": "用户不属于香港 Distribution Group",
  "syncConfig.rulesRow3": "香港通讯组成员未在同步用户目录中找到",
  "syncConfig.regionHk": "香港",
  "syncConfig.regionMainland": "中国大陆",
  "syncConfig.regionUnmatched": "未匹配",
  "syncConfig.roleHkStaff": "香港员工",
  "syncConfig.roleStaff": "员工",
  "syncConfig.roleNone": "未分配角色",
  "syncConfig.disableRegionTitle": "停用区域分配？",
  "syncConfig.enableRegionTitle": "启用区域分配？",
  "syncConfig.disableRegionDesc": "新同步的用户将不再被标记区域或角色。已有分配将保留。",
  "syncConfig.enableRegionDesc": "这将恢复为同步用户标记区域与角色。",
  "syncConfig.disable": "停用",
  "syncConfig.enable": "启用",

  // Permission tip
  "syncConfig.permissionTitle": "需要 Microsoft Graph 权限",
  "syncConfig.permissionDesc":
    "读取通讯组成员并展开嵌套组需要 Microsoft Graph 应用程序权限 GroupMember.Read.All（需管理员同意）。该权限为只读，不会提供对 SharePoint 内容、Teams 消息、邮件、日历、文件或文档的访问。",

  // Action bar
  "syncConfig.saving": "保存中...",
  "syncConfig.saveAll": "保存并同步",
  "syncConfig.edit": "编辑",
  "syncConfig.finish": "完成",

  // Reset modal
  "syncConfig.resetTitle": "重置同步设置？",
  "syncConfig.resetDesc":
    "这将清除当前的用户来源与区域分配配置，使页面恢复为未配置状态。已保存的区域与角色分配将丢失。",
  "syncConfig.resetBtn": "重置",

  "maintenance.title": "维护模式",
  "maintenance.description": "开启后，非管理员用户登录后将看到维护页，且无法使用任何功能",
  "maintenance.pageTitle": "系统维护中",
  "maintenance.pageMessage": "系统正在进行维护，请稍后再试。",
  "maintenance.message": "维护文案",
  "maintenance.messageHint": "该文案将显示在前台维护页。",
  "maintenance.messageRequired": "请先填写维护文案，再开启维护模式。",
  "maintenance.save": "保存",
  "maintenance.saved": "已保存",
  "maintenance.saveFailed": "维护设置保存失败，请重试。",
  "maintenance.logout": "退出登录",
};

export default translation;
